import { Component, EventEmitter, Output, Input, signal, WritableSignal} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-notification-popup',
    imports: [CommonModule, FormsModule, DialogModule, FontAwesomeModule],
    templateUrl: './notification-popup.component.html',
    styleUrl: './notification-popup.component.scss'
})
export class NotificationPopupComponent {

//  constructor(library: FaIconLibrary) {
//    library.addIcons(faChevronDown);
//  }

  @Output() close = new EventEmitter<void>();
  @Input() isVisible!: WritableSignal<boolean>;
  @Input() errorMessage: string = '';
  @Input() secondErrorMessage: string = '';


 onCloseModal() {
  this.isVisible.set(false);
  this.close.emit();
}
}
